import type { UseFormReturn } from 'react-hook-form'
import { CardHeader, RadioGroup, Checkbox } from '@orientamos/ui'
import type { IntakeFormData } from '@orientamos/shared'

interface Step1Props {
  form: UseFormReturn<IntakeFormData>
}

export function Step1ContractType({ form }: Step1Props) {
  const {
    watch,
    setValue,
    formState: { errors },
  } = form
  const contractType = watch('contractType')
  const guaranteedRent = watch('guaranteedRent')

  return (
    <div className="space-y-8">
      <CardHeader
        title="Tipo de Contrato"
        description="Selecciona el tipo de contrato y las opciones de arrendamiento"
      />

      <div className="space-y-6">
        <RadioGroup
          name="contractType"
          label="Tipo de Contrato"
          options={[
            {
              value: 'residential',
              label: 'Arrendamiento Residencial',
              description: 'Contrato para vivienda urbana',
            },
            {
              value: 'commercial',
              label: 'Arrendamiento Comercial',
              description: 'Contrato para locales comerciales, oficinas o bodegas',
            },
          ]}
          value={contractType}
          onChange={(value) => setValue('contractType', value as 'residential' | 'commercial')}
          error={errors.contractType?.message}
        />

        <div className="pt-4 border-t border-neutral-200">
          <Checkbox
            checked={guaranteedRent}
            onChange={(e) => setValue('guaranteedRent', e.target.checked)}
            label="Canon Garantizado"
            description="Marcar si el arrendamiento incluye garantia de canon por parte de Orientamos"
          />
        </div>
      </div>
    </div>
  )
}
